<template>
  <div>
    <div class="row w-100">
      <div class="col-4">
        <base-select v-model="form.isMunicipality"
                     :options="formFieldData.yesno"
                     :validation="val.form.isMunicipality"
                     label="Are you a Nonprofit or Municipality?">
        </base-select>
      </div>
    </div>
    <div class="w-100" v-if="form.isMunicipality != null">
      <div class="row w-100">
        <div class="col-6">
          <yes-no v-model="form.hasPermit"
                  label="Do you have a State Permit?"
                  message="A State Permit is required to complete an Open Burn Permit" />
        </div>
        <div class="col-6" v-if="form.hasPermit">
          <base-file-uploader v-model="form.files.statePermit"
                              label="State Permit"
                              :file="form.existingFileDetails.statePermit"
                              :validation="val.form.files.statePermit" />
        </div>
      </div>
      <div class="row w-100" v-if="!form.hasPermit">
        <div class="col">
          <p class="warning-text"> A valid State Permit is required to submit an Open Burn Application.</p>
        </div>
      </div>
    </div>
    <bottom-navigation link="applicantinfo" v-bind:style="[form.files.statePermit == null && form.existingFileDetails.statePermit == null ? { 'pointer-events': 'none' } : {}]">Applicant Information</bottom-navigation>
  </div>
</template>

<script>
import YesNo from '~/components/YesNo';
import BaseInput from '~/components/BaseInput';
import BaseCheckbox from '~/components/BaseCheckbox';
import BaseFileUploader from '~/components/BaseFileUploader';
import BaseSelect from '~/components/BaseSelect';
import BottomNavigation from '~/components/BottomNavigation';

import { OpenBurnFormData } from '../../../js/FormObjects';

export default {
  name: 'PermitVerification',
  props: ['form', 'val'],
  components: {
    YesNo, BaseInput, BaseCheckbox, BaseFileUploader, BaseSelect, BottomNavigation,
  },
  data() {
    return {
      registerUrl: '',
      loginUrl: '',
      formFieldData: new OpenBurnFormData(),
    };
  },
  mounted() {
    console.log('mounted');
  },
  methods: {

  },
};

</script>
